import { squareToPixel } from '../plot/utils/graph.utils';

export const DISPLAY_SYSTEMS = ['us', 'standard'] as const;
export type RestingDisplay = typeof DISPLAY_SYSTEMS[number];
export const isRestingDisplay = (displaySetting: string | null) =>
  DISPLAY_SYSTEMS.some((d) => d === displaySetting);

export const TECH_CHARAC_CATEGORY = 'Technical characteristics';
export const RHYTHM_CONDUC_CATEGORY = 'Rhythm and conduction';
export const PQRS_MORPHO_CATEGORY = 'P-QRS morphology';
export const REPOL_PATHO_CATEGORY = 'Repolarization and rare pathologies';
export const OTHER_CATEGORY = 'Other';

export const RESTING_LABELS_CATEGORIES = [
  TECH_CHARAC_CATEGORY,
  RHYTHM_CONDUC_CATEGORY,
  PQRS_MORPHO_CATEGORY,
  REPOL_PATHO_CATEGORY,
  OTHER_CATEGORY,
] as const;

export type RestingCategories = typeof RESTING_LABELS_CATEGORIES[number];

export const RESTING_STRIP_HEIGHT = squareToPixel(4.8);
export const RESTING_STRIP_WIDTH = squareToPixel(60);
export const RESTING_LEAD_TEXT_OFFSET = 20;
export const RESTING_LEAD_COUNT = 12;
export const RESTING_DURATION_ON_SCREEN = 10_000; // ms
export const RESTING_ONSET_ON_SCREEN = 5_000; // ms
export const RESTING_OFFSET_ON_SCREEN = 5_000; // ms

export const getRestingDisplay = (
  leads: string[],
  system: RestingDisplay = 'us',
) => {
  switch (system) {
    case 'standard':
      return [leads.slice(0, 6), leads.slice(6)];
    case 'us':
      return [
        leads.slice(0, 3),
        leads.slice(3, 6),
        leads.slice(6, 9),
        leads.slice(9),
      ];
  }
};

export interface GroupSettings {
  pathGroupMapping: { [key: string]: RestingCategories };
  groupOrder: RestingCategories[];
}

export const ANNOTATION_TABLE_GROUPING: Record<string, GroupSettings> = {
  resting_2024: {
    pathGroupMapping: {
      Automatisme: RHYTHM_CONDUC_CATEGORY,
      Méta: TECH_CHARAC_CATEGORY,
      P: PQRS_MORPHO_CATEGORY,
      Pathologie: REPOL_PATHO_CATEGORY,
      PR: RHYTHM_CONDUC_CATEGORY,
      QRS: PQRS_MORPHO_CATEGORY,
      Repolarisation: REPOL_PATHO_CATEGORY,
      Rythme: RHYTHM_CONDUC_CATEGORY,
      Technique: TECH_CHARAC_CATEGORY,
    },
    groupOrder: [
      TECH_CHARAC_CATEGORY,
      RHYTHM_CONDUC_CATEGORY,
      PQRS_MORPHO_CATEGORY,
      REPOL_PATHO_CATEGORY,
      OTHER_CATEGORY,
    ],
  },
};

export const IVCD_EXCLUSION_LABEL_CODES = [
  'CL_qrs_morpho_18',
  'CL_qrs_morpho_3',
  'CL_qrs_morpho_5',
  'CL_qrs_morpho_7',
  'CL_qrs_morpho_8',
  'CL_qrs_morpho_1',
  'CL_qrs_morpho_2',
];
export const AVB1_EXCLUSION_LABEL_CODES = [
  'CL_pr_9', // AVB3
  'CL_pr_8', // AV high-grade
  'CL_pr_7', // AV 2/1
  'CL_pr_4', // Mobitz 1
  'CL_pr_6', //Mobitz 2
];
